import { useEffect, useState } from "react";
import { Row, Col, DatePicker, Popover, Tooltip } from "antd";
import moment from "moment";
import { sumBy, isEmpty, find, get, cloneDeep } from "lodash";

import Card from "@components/card";
import HospitalBed from "@assets/hospitalBed.svg";
import Dollar from "@assets/dollar.svg";
import Graph from "@assets/Graph.svg";
import Admission from "@assets/Admission.svg";
import AccidentAndEmergency from "@assets/AccidentAndEmergency.svg";
import Discharge from "@assets/Discharge.svg";
import Link from "@components/link";
import "./keyInsight.scss";
import { useConfigStore } from "@stores/useConfigStore";
import { getClientName, getFormateForClient, formatNumber, centricClientCheck } from "@utils/helpers";
import { useMemberListStore } from "@stores/useMemberListStore";
import { dateFormatConfig } from "@utils/constants";
import Icon from "@assets/icon_config";
import membersService from "@services/members.service";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";

const { RangePicker } = DatePicker;

const KeyInsight: any = ({
  masterData,
  handleAdtClicks,
  defaultAdmitAndDischargeEndDate,
  defaultAdmitAndDischargeStartDate,
  isloadingCaseStatus,
  memberTypeChangeHandler,
  caseLoadCount,
  serviceCallForCaseLoadMasterData,
  pageDataLoadingStatus,
  masterDataForAdmitAndDischarge,
  setMasterDataForAdmitAndDischarge,
}: any) => {
  // const [calendarType, setCalendarType] = useState();

  // const calendaTypeChangeHandler = (e: any) => {
  //     setCalendarType(e.target.value);
  // };

  // const [masterData1, setMasterData] = useState<any>({});
  // const [currentCost, setCurrentCost] = useState(0);
  // const [previousCost, setPreviousCost] = useState(0);
  // const [percentChange, setPercentChange] = useState(0);

  // const [loader, setLoader] = useState<boolean>(false);
  const selectedMemberType = useMemberListStore((state) => state.selectedMemberType);
  const setDefaultAdmitAndDischargeStartDate = useMemberListStore((state) => state.setDefaultAdmitAndDischargeStartDate);
  const setDefaultAdmitAndDischargeEndDate = useMemberListStore((state) => state.setDefaultAdmitAndDischargeEndDate);

  const registryDependentMemberListPageStore = useMemberListStore((state) => state.registryDependentMemberListPageStore);
  const setRegistryDependentMemberListPageStore = useMemberListStore((state) => state.setRegistryDependentMemberListPageStore);
  const memberListRegistryDropDown = useMemberListStore((state) => state.memberListRegistryDropDown);

  const setADTPatientIdList = useMemberListStore((state) => state.setADTPatientIdList);

  const [isloadingAdmitAndDischargePage, setIsloadingAdmitAndDischargePage] = useState(false);
  const [isloadingAdmitAndDischarge, setIsloadingAdmitAndDischarge] = useState(false);
  // const caseLoadLoader = useMemberListStore((state) => state.caseLoadLoader);
  const config: any = useConfigStore((state) => state.config);

  const [maxLenCheck, setMaxLenCheck] = useState<boolean>(false);
  const isCentric = centricClientCheck()

  const kpiCardsConfig: any = {};
  if (config) {
    config.member_list["KPI Cards"].optionValues
      .filter((opt: any) => opt.show)
      .forEach((option: any) => {
        kpiCardsConfig[option.name] = option.show;
      });
  }

  // const formatDate = (date: any) => {
  //   return formatDisplayDate(date, "reminderDateActualFormat", "createDateFormat");
  // };

  /* 
    ER , Admission, discharge and inpatient service handlers
  */
  useEffect(() => {
      if (kpiCardsConfig["Total Hospital Admission"] || kpiCardsConfig["Total Inpatient"] || kpiCardsConfig["Recently discharged"]) {
        getAdmissionAndDischargeData();
      }
  }, [config]);

  const getAdmissionAndDischargeData = async () => {
    const startOfMonth = defaultAdmitAndDischargeStartDate ? moment(defaultAdmitAndDischargeStartDate).format("YYYY-MMM-DD") : moment().subtract(7, 'days').format(getFormateForClient());
    const endOfMonth = defaultAdmitAndDischargeEndDate ? moment(defaultAdmitAndDischargeEndDate).format("YYYY-MMM-DD") : moment().format(getFormateForClient());
    setIsloadingAdmitAndDischargePage(true);
    defaultAdmitAndDischargeStartDate
      ? setDefaultAdmitAndDischargeStartDate(moment(moment(defaultAdmitAndDischargeStartDate).format("DD MMM'YY")))
      : setDefaultAdmitAndDischargeStartDate(startOfMonth);
    defaultAdmitAndDischargeEndDate ? setDefaultAdmitAndDischargeEndDate(moment(moment(defaultAdmitAndDischargeEndDate).format("DD MMM'YY"))) : setDefaultAdmitAndDischargeEndDate(endOfMonth);
    serviceCallForAdmitAndDischargeOfPaient(startOfMonth, endOfMonth);
  };

  const handleDateChangeFilterInsight = (range: any) => {
    const startDate = range && range.length > 0 ? range[0].format("YYYY-MM-DD") : "";
    const endDate = range && range.length > 0 ? range[1].format("YYYY-MM-DD") : "";
    startDate !== "" && endDate !== "" ? setIsloadingAdmitAndDischarge(true) : setIsloadingAdmitAndDischarge(false);
    setDefaultAdmitAndDischargeStartDate(moment(moment(startDate).format("DD MMM'YY")));
    setDefaultAdmitAndDischargeEndDate(moment(moment(endDate).format("DD MMM'YY")));
    serviceCallForAdmitAndDischargeOfPaient(startDate, endDate, true);
  };

  const serviceCallForAdmitAndDischargeOfPaient = async (startOfMonth: string, endOfMonth: string, onDateRangeChange?: boolean) => {
    if (startOfMonth !== "" && endOfMonth !== "")
      membersService.getMasterDataForAdmissionAndDischarge(startOfMonth, endOfMonth).subscribe({
        next: async (v: any) => {
          const response = v?.data;
          setMasterDataForAdmitAndDischarge(response?.data);
          setADTPatientIdList({
            "Admissions": response?.data?.totalHospitalAdmission?.patientHospitalAdmissionList,
            "Discharges": response?.data?.membersDischarged?.patientHospitalDischargeList,
            "Inpatients": response?.data?.totalHospitalInpatient?.patientHospitalInpatientList,
            "ER": response?.data?.totalErCount?.patientHospitalEmergencyList
          })
          setIsloadingAdmitAndDischarge(false);
          setIsloadingAdmitAndDischargePage(false);

          // If registry selected is from below array then we call member list array
          
          const patientListType = memberListRegistryDropDown.filter((item:any) => item?.value === "PATIENT ID LIST" && item.label !== "Filtered Members")?.map((item:any) => item.label);
          if (onDateRangeChange && patientListType.includes(get(find(memberListRegistryDropDown, { label: selectedMemberType }), "label", ""))) {
            const tempPageStore = cloneDeep(registryDependentMemberListPageStore);
            patientListType?.forEach((item:any) => {
              tempPageStore[item] = 1;
            })
            setRegistryDependentMemberListPageStore(tempPageStore);
            handleAdtClicks(get(find(memberListRegistryDropDown, { label: selectedMemberType }), "label"),response?.data);
          }
        },
        error: (e: any) => {
          console.log(e ? e : "empty");
          setIsloadingAdmitAndDischarge(false);
          setIsloadingAdmitAndDischargePage(false);
        },
      });
  };

  // const clearFields = (e: any) => {
  //   if (e) {
  //     setDefaultAdmitAndDischargeStartDate("");
  //     setDefaultAdmitAndDischargeEndDate("");
  //   }
  // };

  /////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    console.log("KeyInsight.useEffect1");
    const AdmissionDischargeCountLengthCheck = () => {
      console.log("KeyInsight.AdmissionDischargeCountLengthCheck");
      if (
        masterDataForAdmitAndDischarge?.totalHospitalAdmission?.distinctPatientHospitalAdmissionCount.toString().length > 2 ||
        masterDataForAdmitAndDischarge?.membersDischarged?.distinctPatientHospitalDischargeCount.toString().length > 2 ||
        masterDataForAdmitAndDischarge?.totalHospitalInpatient?.count.toString().length > 2 ||
        masterDataForAdmitAndDischarge?.totalErCount?.distinctPatientHospitalErAdmissionCount.toString().length >= 1
      ) {
        setMaxLenCheck(true);
      } else {
        setMaxLenCheck(false);
      }
    };
    AdmissionDischargeCountLengthCheck();
  }, [masterDataForAdmitAndDischarge]);

  useEffect(() => {
    console.log("KeyInsight.useEffect2");
    //Author : Kishore
    //@desc : Commented it to solve the the duplicate api calls
    // handleDateChangeFilterInsight([moment.utc(startDate) , moment.utc(endDate)])
    serviceCallForCaseLoadMasterData();
  }, [defaultAdmitAndDischargeEndDate, defaultAdmitAndDischargeStartDate, serviceCallForCaseLoadMasterData]);

  let distributions = masterData?.caseStatus?.filter((item: any) => item.count !== 0);
  const total: number = sumBy(distributions, (c: any) => c.count);

  const rangeChange = async (range: any) => {
    handleDateChangeFilterInsight(range);
  };

  // Hospital discharge, admission & Er value tooltip
  const getAdmissionDischargeERTooltipContent = (totalCount: any, uniqueCount: any, totalLabel: string, uniqueLabel: any) => {
    return (
      <div className="admissionDischargeERTooltipContent">
        <div className="admissionDischargeERTooltipContent__unique-count">
          <span className="admissionDischargeERTooltipContent__unique-count__value">{uniqueCount}</span>
          {` Unique Members ${uniqueLabel}`}
        </div>
        <div className="admissionDischargeERTooltipContent__unique-count">
          <span className="admissionDischargeERTooltipContent__unique-count__value">{totalCount}</span>
          {` Total ${totalLabel}`}
        </div>
      </div>
    );
  };
  
  return (
    <>
      <div className="membersHeader">
        <div className="pageHeading f24 w500">Members</div>
        {/* <div className="members-right-section">
                    <Radio.Group
                        options={CalendarTypeOption}
                        onChange={calendaTypeChangeHandler}
                        value={calendarType}
                        optionType="button"
                        className="membersCalendarType"
                        size="large"
                    />
                    <DatePicker
                        onChange={() => {}}
                        picker={calendarType}
                        size="large"
                        style={{ width: "184px" }}
                    />
                </div> */}
        {pageDataLoadingStatus && pageDataLoadingStatus?.message && (
          <div className="page-data-loading-information-status-wrapper">
            <div className="page-data-loading-information-status">
              <div className="page-data-loading-information-status__message">
                <span className="page-data-loading-information-status__message__loader">
                  <Icon name={"sandTimerLoader"} />
                </span>
                <span className="page-data-loading-information-status__message__text">{pageDataLoadingStatus?.message}</span>
              </div>
            </div>
          </div>
        )}
      </div>
      {!isCentric && <span style={{ fontSize: "14px", fontWeight: 400, color: "#838ea0" }}>Assigned Member</span>}
      {Object.keys(kpiCardsConfig).length > 0 && (
        <Row className="keyInsights" gutter={[16, 16]}>
          {kpiCardsConfig["Case status Distribution"] && (
            <Col style={{ padding: "8px 0px 8px 8px" }} className="caseLoad">
              <Card className="insightCard">
                {!isloadingCaseStatus ? (
                  <>
                    <div className="caseload__wrapper">
                      <img src={Graph} alt="" className="caseload__wrapper__icon" />

                      <div className="caseload__wrapper__content">
                        <Row className="rowTitleKeyInsights">
                          <Col span={13} className="heading-case-load">
                            <h4 className="insightTitle keyinsightTitles tc">Case Status</h4>
                          </Col>
                          <Col span={9} style={{ display: "flex", justifyContent: "flex-end" }}>
                            {caseLoadCount > 0 ? (
                              <Link
                                customOnclick={() => {
                                  handleAdtClicks("Case Load");
                                }}
                                text={
                                  <h4 className="insightTitle keyinsightTitles">
                                    <span className={"case_load"}>
                                      <span className={"case_load__title"}>Caseload: </span>

                                      <span className={caseLoadCount > 0 ? "case_load__value clr-blueLink" : "case_load__value grey-color"}>
                                        {caseLoadCount}
                                        {/* {caseLoadCount > 0 ? <Icon name={`arrowRight`} colorOfBrand={"#EF7C41"} /> : null} */}
                                      </span>
                                    </span>
                                  </h4>
                                }
                              />
                            ) : (
                              <h4 className="insightTitle keyinsightTitles">
                                <span className="case_load_light">Caseload: {caseLoadCount}</span>
                              </h4>
                            )}
                          </Col>
                        </Row>
                        <div className="ui-csd-dropdown">
                          <h4 className="insightTitle keyinsightTitles tc">Case Status</h4>
                          {/* 
                        <Select
                          className="ui-csd-selector"
                          popupClassName="ui-csd-selector-menu"
                          placement="bottomRight"
                          defaultValue="all_members"
                          onChange={
                            value => {
                              handleAdtClicks(value)
                            }
                          }
                          options={[
                            { value: 'all_members', label: 'All Members: 6,000' },
                            { value: 'isCaseLoad', label: `Caseload: ${caseLoadCount}` },
                            { value: 'all_members', label: 'Assigned Members: 1000' }
                          ]}
                        />
                         */}
                          <span className="ui-csd-dropdown-value">All Members: {formatNumber(total)}</span>
                        </div>
                        {/* <Row className="rowContainerKeyInsightsCaseStatus "> */}
                        {isEmpty(masterData?.caseStatus) ? (
                          <DataNotFound message={NO_DATA_FOUND} />
                        ) : (
                          <div className="ui-csd-content">
                            <div className="ui-csd-graph">
                              <div className="ui-csd-chart">
                                <div className="ui-csd-chart-bars">
                                  {!isEmpty(masterData?.caseStatus) &&
                                    masterData?.caseStatus.map((el: any, index: number) => {
                                      const percent = Math.round((el.count / total) * 100);
                                      const status = el.status.toLowerCase().replace(" ", "");
                                      return (
                                        <Popover
                                          content={
                                            <div className="ui-csd-chart-bar-popover">
                                              <div className={`ui-csd-chart-bar-popover-status ui-csd-chart-bar-popover-status`} style={{ backgroundColor: el?.color }}></div>
                                              <div className="ui-csd-chart-bar-popover-title">{el.status}</div>
                                              <div className="ui-csd-chart-bar-popover-value">{percent || 0}%</div>
                                            </div>
                                          }
                                        >
                                          <div className={`ui-csd-chart-bar`}>
                                            <div
                                              className={` ui-csd-chart-bar-value ui-csd-chart-bar-value`}
                                              style={{ height: `${percent === 0 ? 3 : percent + 5}%`, borderRadius: `${percent === 0 ? "0  0 5px 5px" : "5px"}`, backgroundColor: el?.color }}
                                            ></div>
                                          </div>
                                        </Popover>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div className="ui-csd-legends" style={{ "--column-number": Math.ceil(Math.sqrt(masterData?.caseStatus?.length)) } as React.CSSProperties}>
                              {!isEmpty(masterData?.caseStatus) &&
                                masterData?.caseStatus.map((el: any, index: number) => {
                                  return (
                                    <div className="ui-csd-legend">
                                      <div className={`ui-csd-legend-indicator`} style={{ backgroundColor: el?.color }}></div>
                                      <div className="ui-csd-legend-title">{el.status}</div>
                                      <div className="ui-csd-legend-count">{el.count}</div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        )}
                        {/*                       
                      <Row className="caseStatusColumnWrapper">
                        {masterData?.totalPredictedCostSaving?.careManagerID !== "" && masterData?.caseStatus.map((el: any, index: number) => {
                          const classNameTitle = classNames("statusCount f18 w500", {
                            "grey-color": el.count === 0,
                            "clr-blueLink": el.count > 0,
                            "statusCount--disable": el.count === 0
                          })
                          let className = el.status.replace(" ", "");
                          const percent: string = ((el.count / total) * 100).toFixed(0);
                          return (
                            <div className="caseStatusColumn" key={`caseStatusColumn${index}`}>
                              <div className="insightContentCaseStatus">
                                <div className={`indicator ${className.toLowerCase()}`}></div>
                                <div className="status">{el.status}</div>
                              </div>
                              <div className={classNameTitle} onClick={() => el.count > 0 ? handleTopCardAdtClicks(el.status) : noop()}>
                                {`${el.count}`}
                                <span className="ver-aln__sub"></span>
                              </div>
                              <div className="statusCountPercent">{`${percent}%`}</div>
                            </div>
                          );
                        })}
                        
                      </Row>
                      */}
                        {/* </Row> */}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <Row className="rowTitleKeyInsights">
                      <Col span={2}>
                        <div className="iconPreload shimmerBG" />
                      </Col>
                      <Col span={13}>
                        <div className="keyinsightTitles titlePreloader shimmerBG"></div>
                      </Col>
                      <Col span={9}>
                        <div className="keyinsightTitles titlePreloader shimmerBG"></div>
                      </Col>
                    </Row>
                    <div className="rowContainerKeyInsights caseStatus">
                      <Row>
                        <div className="predictedCostSavingPreload shimmerBG"></div>
                      </Row>
                      <Row>
                        <div className="lastMonthSavingPreload shimmerBG"></div>
                      </Row>
                    </div>
                  </>
                )}
              </Card>
            </Col>
          )}
          {/* //////////////////////////////////////////insightTitle case-status f14 w500  */}

          {kpiCardsConfig["Predicted Cost Saving"] && (
            <Col style={{ padding: "8px 0px 8px 8px" }} className="card2">
              <Card className="insightCard">
                {!isloadingCaseStatus ? (
                  <>
                  <div className="card2__wrapper">
                    <img src={Dollar} alt="" className="card2__wrapper__icon" />
                    <div className="card2__wrapper__content">
                      <Row className="rowTitleKeyInsights">
                        <Col className="heading-case-load">
                          <h4 className="insightTitle keyinsightTitles tc">Last 12 months' Expenses</h4>
                        </Col>
                      </Row>
                      {isEmpty(masterData?.totalPredictedCostSaving) ? (
                        <DataNotFound message={NO_DATA_FOUND} />
                      ) : (
                        <>
                          <Row className="caseStatusColumnWrapper">
                            <div className="f18 w500" style={{ color: "#091e42" }}>
                              $ {Number(masterData?.totalPredictedCostSaving?.predictedCostSaving)?.toLocaleString()}
                            </div>
                          </Row>
                          <Row className="caseStatusColumnWrapper">
                            <div>
                              $ {masterData?.totalPredictedCostSaving?.previousPredictedCostSaving.toLocaleString()}
                              <br />
                              <i style={{ fontSize: "12px" }}>(Prior Trailing 12 Months' Expenses)</i>
                            </div>
                          </Row>
                        </>
                      )}
                    </div>
                  </div>
                  </>
                ) : (
                  // <>
                  //   <Row className="rowTitleKeyInsights">
                  //     <Col>
                  //       <img src={Dollar} alt="" className="insightIcon" />
                  //     </Col>
                  //     <Col>
                  //       <h4 className="insightTitle keyinsightTitles">Last 12 months Expenses</h4>
                  //     </Col>
                  //   </Row>
                  //   <div className="rowContainerKeyInsights">
                  //     <Row>
                  //       <div className="f18 w500" style={{ color: "#091e42" }}>
                  //         $ {Number(masterData?.totalPredictedCostSaving?.predictedCostSaving)?.toLocaleString()}
                  //       </div>
                  //     </Row>
                  //     <Row style={{ marginTop: "0.3rem" }}>
                  //       <div>
                  //         $ {masterData?.totalPredictedCostSaving?.previousPredictedCostSaving.toLocaleString()}
                  //         <br />
                  //         <i style={{ fontSize: "12px" }}>(Prior Trailing 12 Month’s Expenses)</i>
                  //       </div>
                  //     </Row>
                  //   </div>
                  // </>
                  <>
                    <Row className="rowTitleKeyInsights">
                      <Col>
                        <div className="iconPreload shimmerBG" />
                      </Col>
                      <Col>
                        <div className="keyinsightTitles titlePreloader shimmerBG"></div>
                      </Col>
                    </Row>
                    <div className="rowContainerKeyInsights">
                      <Row>
                        <div className="predictedCostSavingPreload shimmerBG"></div>
                      </Row>
                      <Row>
                        <div className="lastMonthSavingPreload shimmerBG"></div>
                      </Row>
                    </div>
                  </>
                )}
              </Card>
            </Col>
          )}

          {(kpiCardsConfig["Total Hospital Admission"] || kpiCardsConfig["Total Inpatient"] || kpiCardsConfig["Recently discharged"]) && (
            <Col className="admissionDischargeRow">
              <Card className="insightCard">
                <Row className=" rowTitleKeyInsights admissionAndDischargeTitle">
                  {!isloadingAdmitAndDischargePage ? (
                    <>
                      <div className="admissionAndDischargeTitleItems">
                        <h4 className="insightTitle keyinsightTitles ">
                          ER, Admissions & Discharges <br />
                          <span style={{ fontSize: "14px", fontWeight: 400, color: "#838ea0" }}>
                            <i>(No. of Unique Members)</i>
                          </span>
                        </h4>
                      </div>

                      <div className="reminderDatePickerKeyInsight">
                        <div className="reminderDateLabel">
                          <span className="icon-calendar f18" />
                        </div>
                        <RangePicker
                          separator={<span className="range-picker-separator"> -</span>}
                          picker="date"
                          size="middle"
                          format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                          allowClear={false}
                          dropdownClassName="reminder-pickerKeyInsight"
                          value={
                            defaultAdmitAndDischargeStartDate !== "" && defaultAdmitAndDischargeEndDate !== ""
                              ? [moment(moment(defaultAdmitAndDischargeStartDate).format("MM/DD/YYYY")), moment(moment(defaultAdmitAndDischargeEndDate).format("MM/DD/YYYY"))]
                              : undefined
                          }
                          ranges={{
                            "More Filters:": [null, null],
                            "Last 1 Day": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                            "Last 7 Days": [moment().subtract(7, "days"), moment()],
                            "Current Month to Date": [moment(moment().startOf("month").format(getFormateForClient())), moment()],
                          }}
                          onChange={(range: any) => {
                            rangeChange(range);
                          }}
                          // onOpenChange={(e) => {
                          //   clearFields(e);
                          // }}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="admissionAndDischargeTitleItems">
                        <div className="insightTitle keyinsightTitles preloader shimmerBG"></div>
                      </div>
                      <div className="reminderDatePickerKeyInsight__preloader shimmerBG"></div>
                    </>
                  )}
                </Row>
                <Col className="rowContainerKeyInsightsAdmitAndDischarge">
                  {kpiCardsConfig["Total Inpatient"] && (
                    <Row className={`admissionAndDischargeCard`}>
                      {!isloadingAdmitAndDischargePage ? (
                        <>
                          <Row className="title-row">
                            <Col>
                              <img src={HospitalBed} alt="" className="insightIcon" />
                            </Col>
                            <Col className={`title-row__column ${maxLenCheck ? "fl-dir_col" : ""}`}>
                              <h4 className="insightTitle keyinsightTitles adt-title">Inpatients</h4>

                              {!isloadingAdmitAndDischarge ? (
                                <div className="rowContainerKeyInsights adt_clicks">
                                  {masterDataForAdmitAndDischarge?.totalHospitalInpatient?.count > 0 ? (
                                    <Link
                                      customOnclick={() => {
                                        handleAdtClicks("Inpatients");
                                      }}
                                      text={
                                        <div className="membercount">
                                          <span>{`${masterDataForAdmitAndDischarge?.totalHospitalInpatient?.count}`}</span>
                                          {/* <span style={{ display: "flex", alignItems: "center", marginLeft: "20px" }}>{`>`}</span> */}
                                          <span style={{ display: "flex", alignItems: "center" }}>{/* <Icon name={`arrowRight`} colorOfBrand={"#0072E3"} /> */}</span>
                                        </div>
                                      }
                                      className="clr-blueLink f18 w500 membercount"
                                    />
                                  ) : (
                                    <span className="grey-color f18 w500 membercount">{`${masterDataForAdmitAndDischarge?.totalHospitalInpatient?.count}`}</span>
                                  )}
                                </div>
                              ) : (
                                <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className="rowPreLoader" style={{ margin: "0" }}>
                            <Col>
                              <div className="insightIconPreloader shimmerBG " />
                            </Col>
                            <Col>
                              <div className="insightTitlePreLoader shimmerBG "></div>
                            </Col>
                          </Row>
                          <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                        </>
                      )}
                    </Row>
                  )}
                  {kpiCardsConfig["Total Hospital Admission"] && (
                    <Row className={`admissionAndDischargeCard`}>
                      {!isloadingAdmitAndDischargePage ? (
                        <>
                          <Row className="title-row">
                            <Col>
                              <img src={Admission} alt="" className="insightIcon" />
                            </Col>
                            <Col className={`title-row__column ${maxLenCheck ? "fl-dir_col" : ""}`}>
                              {!isloadingAdmitAndDischarge ? (
                                <Tooltip
                                  placement="bottom"
                                  overlayClassName="admissionDischargeERTooltipCount"
                                  title={getAdmissionDischargeERTooltipContent(
                                    masterDataForAdmitAndDischarge?.totalHospitalAdmission?.totalPatientHospitalAdmissionCount,
                                    masterDataForAdmitAndDischarge?.totalHospitalAdmission?.distinctPatientHospitalAdmissionCount,
                                    "Admissions",
                                    "Admitted"
                                  )}
                                >
                                  <h4 className="insightTitle keyinsightTitles adt-title">Admissions</h4>
                                  <div className="rowContainerKeyInsights adt_clicks">
                                    {masterDataForAdmitAndDischarge?.totalHospitalAdmission?.distinctPatientHospitalAdmissionCount > 0 ? (
                                      <Link
                                        customOnclick={() => {
                                          handleAdtClicks("Admissions");
                                        }}
                                        text={
                                          <div className="membercount">
                                            <span>{`${masterDataForAdmitAndDischarge?.totalHospitalAdmission?.distinctPatientHospitalAdmissionCount}`}</span>
                                            <span style={{ display: "flex", alignItems: "center" }}>{/* <Icon name={`arrowRight`} colorOfBrand={"#0072E3"} /> */}</span>
                                          </div>
                                        }
                                        className="clr-blueLink f18 w500 membercount"
                                      />
                                    ) : (
                                      <span className="grey-color f18 w500 membercount">{`${masterDataForAdmitAndDischarge?.totalHospitalAdmission?.distinctPatientHospitalAdmissionCount}`}</span>
                                    )}
                                  </div>
                                </Tooltip>
                              ) : (
                                <>
                                  <h4 className="insightTitle keyinsightTitles adt-title">Admissions</h4>
                                  <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                                </>
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className="rowPreLoader" style={{ margin: "0" }}>
                            <Col>
                              <div className="insightIconPreloader shimmerBG " />
                            </Col>
                            <Col>
                              <div className="insightTitlePreLoader shimmerBG "></div>
                            </Col>
                          </Row>
                          <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                        </>
                      )}
                    </Row>
                  )}
                  {kpiCardsConfig["Recently discharged"] && (
                    <Row className={`admissionAndDischargeCard`}>
                      {!isloadingAdmitAndDischargePage ? (
                        <>
                          <Row className="title-row">
                            <Col>
                              <img src={Discharge} alt="" className="insightIcon" />
                            </Col>
                            <Col className={`title-row__column ${maxLenCheck ? "fl-dir_col" : ""}`}>
                              {!isloadingAdmitAndDischarge ? (
                                <Tooltip
                                  placement="bottom"
                                  overlayClassName="admissionDischargeERTooltipCount"
                                  title={getAdmissionDischargeERTooltipContent(
                                    masterDataForAdmitAndDischarge?.membersDischarged?.totalPatientHospitalDischargeCount,
                                    masterDataForAdmitAndDischarge?.membersDischarged?.distinctPatientHospitalDischargeCount,
                                    "Discharges",
                                    "Discharged"
                                  )}
                                >
                                  <h4 className="insightTitle keyinsightTitles adt-title">Discharges</h4>
                                  <div className="rowContainerKeyInsights adt_clicks">
                                    {masterDataForAdmitAndDischarge?.membersDischarged?.distinctPatientHospitalDischargeCount > 0 ? (
                                      <Link
                                        customOnclick={() => {
                                          handleAdtClicks("Discharges");
                                        }}
                                        text={
                                          <div className="membercount">
                                            <span>
                                              {`${masterDataForAdmitAndDischarge?.membersDischarged?.distinctPatientHospitalDischargeCount}`}
                                              {/* <span style={{ fontWeight: "400", fontSize: "14px" }}>(Under Care)</span> */}
                                            </span>
                                            {/* <span style={{ display: "flex", alignItems: "center", marginLeft: "20px" }}>{`>`}</span> */}
                                            <span style={{ display: "flex", alignItems: "center" }}>{/* <Icon name={`arrowRight`} colorOfBrand={"#0072E3"} /> */}</span>
                                          </div>
                                        }
                                        className="clr-blueLink f18 w500 membercount"
                                      />
                                    ) : (
                                      <span className="grey-color f18 w500 membercount">{`${masterDataForAdmitAndDischarge?.membersDischarged?.distinctPatientHospitalDischargeCount}`}</span>
                                    )}
                                  </div>
                                </Tooltip>
                              ) : (
                                <>
                                  <h4 className="insightTitle keyinsightTitles adt-title">Discharges</h4>
                                  <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                                </>
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className="rowPreLoader" style={{ margin: "0" }}>
                            <Col>
                              <div className="insightIconPreloader shimmerBG " />
                            </Col>
                            <Col>
                              <div className="insightTitlePreLoader shimmerBG "></div>
                            </Col>
                          </Row>
                          <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                        </>
                      )}
                    </Row>
                  )}

                  {kpiCardsConfig["Total Hospital Admission"] && (
                    <>
                      <Row className={`admissionAndDischargeCard`}>
                        {!isloadingAdmitAndDischargePage ? (
                          <Row className="title-row">
                            <Col>
                              <div className="seperator"></div>
                            </Col>
                            <Col>
                              <img src={AccidentAndEmergency} alt="" className="insightIcon" />
                            </Col>
                            <Col className={`title-row__column ${maxLenCheck ? "fl-dir_col" : ""}`}>
                              {!isloadingAdmitAndDischarge ? (
                                <Tooltip
                                  placement="bottom"
                                  overlayClassName="admissionDischargeERTooltipCount"
                                  title={getAdmissionDischargeERTooltipContent(
                                    masterDataForAdmitAndDischarge?.totalErCount?.totalPatientHospitalErAdmissionCount,
                                    masterDataForAdmitAndDischarge?.totalErCount?.distinctPatientHospitalErAdmissionCount,
                                    "ER Visits",
                                    "ER Visits"
                                  )}
                                >
                                  <h4 className="insightTitle keyinsightTitles adt-title">ER</h4>
                                  <div className="rowContainerKeyInsights adt_clicks">
                                    {masterDataForAdmitAndDischarge?.totalErCount?.distinctPatientHospitalErAdmissionCount > 0 ? (
                                      <Link
                                        customOnclick={() => {
                                          handleAdtClicks("ER");
                                        }}
                                        text={
                                          <div className="membercount">
                                            <span>{`${masterDataForAdmitAndDischarge?.totalErCount?.distinctPatientHospitalErAdmissionCount}`}</span>
                                            <span style={{ display: "flex", alignItems: "center" }}>{/* <Icon name={`arrowRight`} colorOfBrand={"#0072E3"} /> */}</span>
                                          </div>
                                        }
                                        className="clr-blueLink f18 w500 membercount"
                                      />
                                    ) : (
                                      <span className="grey-color f18 w500 membercount">{`${masterDataForAdmitAndDischarge?.totalErCount?.distinctPatientHospitalErAdmissionCount}`}</span>
                                    )}
                                  </div>
                                </Tooltip>
                              ) : (
                                <>
                                  <h4 className="insightTitle keyinsightTitles adt-title">ER</h4>
                                  <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                                </>
                              )}
                            </Col>
                          </Row>
                        ) : (
                          <>
                            <Row className="rowPreLoader" style={{ margin: "0" }}>
                              <Col>
                                <div className="insightIconPreloader shimmerBG " />
                              </Col>
                              <Col>
                                <div className="insightTitlePreLoader shimmerBG "></div>
                              </Col>
                            </Row>
                            <div className="rowContainerKeyInsightsPreloader shimmerBG "></div>
                          </>
                        )}
                      </Row>
                    </>
                  )}
                </Col>
                {/* <div className="admissionAndDischargeBody">
                </div>
            </div> */}
              </Card>
            </Col>
          )}
          {/* <Col flex={1}>
          <Card className="insigtContrainer">
            <div className="title-row">
              <img src={HospitalBed} alt="" className="insightIcon" />
              <h4 className="insightTitle f14 w500">
                Total Admissions
              </h4>
            </div>
            <div className="insightContent">
              <Link
                customOnclick={() => {
                  handleAdtClicks("isAdmitted");
                }}
                text={
                  <span>
                    {masterData?.totalHospitalAdmission?.count} Members
                  </span>
                }
                className="clr-blueLink f18 w500"
              />
              {/* <span className="italic">(No information available)</span> }
            </div>
          </Card>
        </Col>
        <Col flex={1}>
          <Card className="insigtContrainer">
            <div className="title-row">
              <img src={DischargeIcon} alt="" className="insightIcon" />
              <h4 className="insightTitle f14 w500">
                Total Discharges{" "}
              </h4>
            </div>
            <div className="insightContent">
              <Link
                customOnclick={() => {
                  handleAdtClicks("isDischarged");
                }}
                text={
                  <span>{masterData?.membersDischarged?.count} Members</span>
                }
                className="clr-blueLink f18 w500"
              />
              {/* <span className="italic">(No information available)</span> }
            </div>
          </Card>
        </Col> */}
        </Row>
      )}
    </>
  );
};

export default KeyInsight;
